import type { NodeDefinition } from '../types';

export const colorInputNode: NodeDefinition = {
  type: 'input.color',
  category: 'Input',
  label: 'Color Value',
  description: 'Outputs a constant RGBA or hex color value',
  inputs: [],
  outputs: [
    { id: 'color', name: 'Color', type: 'color', defaultValue: '#b99af8' },
  ],
  params: [
    { id: 'value', name: 'Color', type: 'color', defaultValue: '#b99af8' },
  ],
  processor: (_inputs, params) => {
    const val = (params.value as string) || '#b99af8';
    return { color: val };
  },
};
